import React from 'react';
import { trackWhatsAppClick, trackCtaClick } from '../../../utils/gtm';
import { IconWhatsApp, IconArrowRight } from './Icons';

/**
 * Mobile-only sticky bottom bar (≤900px): WhatsApp | Fixed quote.
 * Replaces the shared Call | WhatsApp bar on this page only.
 */
const MobileQuoteBar = ({ onOpenModal }) => (
  <div className="bk-mbar" role="navigation" aria-label="Quick contact">
    <a
      href="https://wa.me/971542119784"
      target="_blank"
      rel="noopener noreferrer"
      className="bk-mbar-btn bk-mbar-btn--wa gtm-whatsapp-btn"
      id="mobileStickyCta-whatsapp"
      data-gtm-id="mobile-sticky-whatsapp"
      data-source="mobile_sticky_bar"
      onClick={() => trackWhatsAppClick('mobile_sticky_bar_whatsapp')}
    >
      <IconWhatsApp size={18} />
      <span>WhatsApp</span>
    </a>
    <button
      type="button"
      className="bk-mbar-btn bk-mbar-btn--quote gtm-cta-btn"
      id="mobileStickyCta-quote"
      data-gtm-id="mobile-sticky-quote"
      data-source="mobile_sticky_bar"
      onClick={() => {
        trackCtaClick('mobile_sticky_bar_quote');
        onOpenModal();
      }}
    >
      <span>Fixed quote</span>
      <IconArrowRight size={14} />
    </button>
  </div>
);

export default MobileQuoteBar;
